export const episodes = [
  {
    id: "ep-01",
    number: 1,
    season: 1,
    title: "搬家之后",
    summary:
      "年轻母亲林慧随丈夫搬入老城区新居，陌生的邻里与婆婆的突然到访，让这个重组的家庭在新环境里迎来第一次考验。",
    content:
      "第一集从清晨的搬家货车开始。林慧抱着熟睡的女儿周晓彤站在老式居民楼下，看着堆满纸箱的新家，心里既有期待也有不安。丈夫陈志远忙着搬运家具，却始终回避关于房贷与工作调动的追问。傍晚时分，婆婆王秀兰不请自来，对厨房的摆设、孩子的作息逐一点评，语气温和却句句带刺。林慧努力维持体面，在厨房独自洗碗时第一次落泪。本集末尾，隔壁传来婴儿的哭声，林慧走到窗前，望着对面亮起的那盏灯，喃喃自语。",
    airDate: "2024-03-12",
    director: "沈知远",
    writers: "沈知远、林一舟",
    cast: "苏雅宁、陆承轩、郑佩云、何以然",
    tags: ["家庭", "搬迁", "婆媳"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20young%20chinese%20mother%20holding%20child%20standing%20in%20front%20of%20old%20residential%20building%20with%20moving%20boxes%2C%20warm%20late%20afternoon%20light%2C%20soft%20muted%20tones%2C%20film%20grain&width=800&height=450&seq=ym2-ep01&orientation=landscape",
  },
  {
    id: "ep-02",
    number: 2,
    season: 1,
    title: "第一次争执",
    summary:
      "晓彤在幼儿园与同伴发生冲突，林慧与陈志远教育理念的分歧被彻底摊开，两人在深夜的客厅里第一次大声争吵。",
    content:
      "晓彤因为抢玩具推倒了同伴，老师把林慧叫到幼儿园。林慧主张先教孩子道歉与共情，陈志远却认为应该先维护孩子的自尊。两人从幼儿园走廊一路争到深夜的客厅：一个担心孩子太懂事会委屈自己，一个担心孩子太强势会被人孤立。争吵中途，晓彤从卧室门缝探出头，两人的声音戛然而止。第二天早晨，餐桌上多了一张孩子画的三个人牵手的小画。林慧把画贴在冰箱上，与丈夫对视一眼，谁都没有先开口。",
    airDate: "2024-03-13",
    director: "沈知远",
    writers: "林一舟",
    cast: "苏雅宁、陆承轩、何以然",
    tags: ["教育", "夫妻关系", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20chinese%20couple%20arguing%20quietly%20in%20dim%20living%20room%20late%20at%20night%2C%20single%20warm%20lamp%2C%20muted%20blue%20tones%2C%20emotional%20close%20up%2C%20film%20grain&width=800&height=450&seq=ym2-ep02&orientation=landscape",
  },
  {
    id: "ep-03",
    number: 3,
    season: 1,
    title: "婆婆的秘密",
    summary:
      "王秀兰执意要长住照顾孙女，林慧偶然在储物间发现一叠旧医院的单据，婆婆多年隐瞒的健康问题浮出水面。",
    content:
      "王秀兰以“帮忙带孩子”为由住了下来，把家里打理得井井有条，却也让林慧感到处处被越界。整理储物间时，林慧翻出一个上了锁的旧铁盒，里面是厚厚一叠复诊单和药盒。她没有声张，只是在晚饭后悄悄给婆婆添了一碗汤。夜里，王秀兰独自坐在阳台，把药瓶收进贴身的口袋。两人隔着半掩的玻璃门彼此沉默，第一次没有针锋相对。本集把婆媳线从对抗推向互相试探。",
    airDate: "2024-03-19",
    director: "沈知远",
    writers: "沈知远、苏晓",
    cast: "苏雅宁、郑佩云",
    tags: ["婆媳", "隐情", "亲情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20elderly%20chinese%20woman%20sitting%20alone%20on%20balcony%20at%20night%20holding%20medicine%20bottle%2C%20soft%20blue%20moonlight%2C%20quiet%20melancholic%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep03&orientation=landscape",
  },
  {
    id: "ep-04",
    number: 4,
    season: 1,
    title: "闺蜜的空降",
    summary:
      "多年未见的闺蜜李静突然出现，带来一份看似体面的工作邀约，也让林慧重新审视自己“只是母亲”的身份焦虑。",
    content:
      "李静开着新车出现在小区门口，把林慧拉去喝下午茶。她讲述自己在外打拼的风光，顺势抛出邀约：一份时间自由、收入可观的合作。林慧心动却又犹豫，她望着手机里女儿的照片，第一次认真思考“我除了是妈妈，还能是谁”。回家后她把这件事压在心底没有告诉丈夫，却在深夜偷偷翻看自己大学时的设计稿。这一集用轻快的节奏，托住了一个沉甸甸的自我认同命题。",
    airDate: "2024-03-20",
    director: "沈知远",
    writers: "苏晓",
    cast: "苏雅宁、白露",
    tags: ["友情", "自我认同", "职场"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20two%20chinese%20women%20chatting%20in%20bright%20modern%20cafe%20by%20large%20window%2C%20afternoon%20sunlight%2C%20warm%20friendly%20mood%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=800&height=450&seq=ym2-ep04&orientation=landscape",
  },
  {
    id: "ep-05",
    number: 5,
    season: 1,
    title: "父亲住院",
    summary:
      "陈志远接到父亲赵建国突发住院的消息，一向强势的他第一次在林慧面前露出脆弱，夫妻关系出现转机。",
    content:
      "凌晨的一通电话打乱了所有计划。赵建国因心脏问题住进医院，陈志远连夜赶去，在走廊长椅上坐了一整夜。林慧带着热粥和换洗衣物出现时，他红着眼眶说了一句“我怕”。这是全剧第一次让这个男人卸下盔甲的时刻。医院的白墙、消毒水味与走廊尽头的窗光，构成了本集最主要的视觉空间。夫妻两人在照顾老人的过程中重新学会了并肩，而不是分工。",
    airDate: "2024-03-26",
    director: "沈知远",
    writers: "林一舟",
    cast: "陆承轩、苏雅宁、秦世忠",
    tags: ["亲情", "夫妻关系", "变故"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20chinese%20man%20sitting%20exhausted%20on%20hospital%20corridor%20bench%20at%20dawn%2C%20cold%20white%20fluorescent%20light%2C%20lonely%20somber%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep05&orientation=landscape",
  },
  {
    id: "ep-06",
    number: 6,
    season: 1,
    title: "职场重逢",
    summary:
      "林慧重返职场的第一天，就与新同事孙婉狭路相逢，两人围绕同一个项目展开明争暗斗，也埋下长线伏笔。",
    content:
      "林慧接受了李静的邀约，第一天走进开放式办公室，却在会议室撞见孙婉——一个八面玲珑、能力出众的老对手。两人被分到同一个项目组，表面上客气寒暄，暗地里各自较劲。林慧熬夜赶出的方案被孙婉四两拨千斤地“优化”，功劳被稀释。她在茶水间听到同事议论，攥紧杯子却没有发作。本集用职场的尖锐，映照出一个母亲重新证明自己的艰难。",
    airDate: "2024-03-27",
    director: "沈知远",
    writers: "苏晓",
    cast: "苏雅宁、顾清瑶、白露",
    tags: ["职场", "竞争", "女性成长"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20chinese%20woman%20standing%20tense%20in%20modern%20office%20meeting%20room%20holding%20documents%2C%20cool%20glass%20and%20blue%20tones%2C%20corporate%20tension%2C%20film%20grain&width=800&height=450&seq=ym2-ep06&orientation=landscape",
  },
  {
    id: "ep-07",
    number: 7,
    season: 1,
    title: "生日失约",
    summary:
      "晓彤的生日当天，林慧因加班失约，母女之间第一次出现冷战，也让林慧开始重新衡量“工作”与“陪伴”。",
    content:
      "生日蛋糕上的蜡烛点了一次又一次。林慧答应回家陪女儿吹蜡烛，却被一场突发汇报拖到深夜。晓彤把蛋糕推给奶奶，一个人抱着玩具回了房间。林慧赶到家时，客厅只剩下融化的奶油和一根没吹灭的蜡烛。她坐在女儿床前道歉，孩子背对着她说不出一句完整的话。这一集是全剧情绪密度最高的一集，也直接引出后续关于“陪伴是否等于牺牲”的讨论。",
    airDate: "2024-04-02",
    director: "沈知远",
    writers: "林一舟",
    cast: "苏雅宁、何以然、郑佩云",
    tags: ["母女", "陪伴", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20birthday%20cake%20with%20melting%20candles%20on%20dark%20dining%20table%20at%20night%2C%20empty%20chair%2C%20warm%20but%20lonely%20tones%2C%20film%20grain&width=800&height=450&seq=ym2-ep07&orientation=landscape",
  },
  {
    id: "ep-08",
    number: 8,
    season: 1,
    title: "旧照片里的人",
    summary:
      "一次家庭整理中，林慧在公公的相册里发现一位陌生女子，一段被尘封多年的往事牵动了整个家庭。",
    content:
      "为了给住院的赵建国腾出房间，全家开始整理旧物。林慧在一本旧相册的夹层里发现一张泛黄的照片：父亲身边站着一位她从未见过的女子。她拿着照片去问婆婆，王秀兰的手停在半空，许久没有说话。往事像被撬开的地板，露出底下的裂纹。本集用一次安静的发现，把家庭叙事从当下的鸡毛蒜皮，拉向更深的代际情感。",
    airDate: "2024-04-03",
    director: "沈知远",
    writers: "沈知远、苏晓",
    cast: "苏雅宁、郑佩云、秦世忠",
    tags: ["往事", "家庭", "悬念"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20hands%20holding%20old%20faded%20family%20photo%20inside%20vintage%20album%2C%20warm%20sepia%20tones%2C%20soft%20window%20light%2C%20nostalgic%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep08&orientation=landscape",
  },
  {
    id: "ep-09",
    number: 9,
    season: 1,
    title: "她的选择",
    summary:
      "孙婉意外得知林慧的家庭状况，主动伸出援手，两人从对手变成某种意义上的盟友，职场线迎来转折。",
    content:
      "项目临近交付，林慧的手忙脚乱被孙婉看在眼里。一次深夜加班，孙婉主动替她挡下了一场应酬，两人在便利店门口吃着关东煮，聊起各自的母亲。原来光鲜的孙婉背后，也有一个独自抚养她长大的母亲。竞争没有消失，但多了一层理解。本集让两个女性的关系变得复杂而真实，也为后段的关键抉择埋下动机。",
    airDate: "2024-04-09",
    director: "沈知远",
    writers: "苏晓",
    cast: "苏雅宁、顾清瑶",
    tags: ["女性友谊", "职场", "理解"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20two%20chinese%20women%20eating%20at%20convenience%20store%20entrance%20late%20at%20night%2C%20warm%20shop%20glow%2C%20candid%20relaxed%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep09&orientation=landscape",
  },
  {
    id: "ep-10",
    number: 10,
    season: 1,
    title: "雨夜和解",
    summary:
      "一场突如其来的暴雨，把林慧和婆婆困在同一屋檐下。两个女人终于坐下来，说出了积压多年的话。",
    content:
      "暴雨切断了小区的供电，家里点起蜡烛。没有电视的噪音，没有孩子的打岔，林慧和王秀兰被迫面对面坐着。婆婆讲起自己当年独自带大孩子的岁月，林慧也说出婚后这些年的委屈。她们没有拥抱，也没有煽情的台词，只是在雨声里把话一点点说完。天亮时，王秀兰把一碗热粥推到林慧面前，说了句“以后别硬撑”。这一集被观众称为“婆媳线的定海神针”。",
    airDate: "2024-04-10",
    director: "沈知远",
    writers: "林一舟",
    cast: "苏雅宁、郑佩云",
    tags: ["婆媳", "和解", "情感"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20two%20chinese%20women%20sitting%20face%20to%20face%20by%20candlelight%20during%20power%20outage%20rainy%20night%2C%20warm%20flame%20glow%2C%20intimate%20quiet%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep10&orientation=landscape",
  },
  {
    id: "ep-11",
    number: 11,
    season: 1,
    title: "无法回避的真相",
    summary:
      "赵建国的病情急转直下，相册里的往事被彻底揭开，陈志远第一次直面父亲的另一段人生。",
    content:
      "医院下达了病危通知。守在床前的赵建国在清醒时把陈志远叫到身边，断断续续说出了照片背后的故事。陈志远沉默地听完，走出病房后在楼梯间抽了整包烟。林慧没有追问，只是递上一杯热水。本集把家庭伦理的复杂性推到台前：理解的边界在哪里，原谅是否一定要有前提。沉重却不煽情，是全剧公认的转折点。",
    airDate: "2024-04-16",
    director: "沈知远",
    writers: "沈知远",
    cast: "陆承轩、秦世忠、苏雅宁",
    tags: ["真相", "亲情", "抉择"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20chinese%20man%20smoking%20alone%20on%20hospital%20stairwell%20deep%20in%20thought%2C%20cold%20grey%20light%2C%20heavy%20emotional%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep11&orientation=landscape",
  },
  {
    id: "ep-12",
    number: 12,
    season: 1,
    title: "重新出发",
    summary:
      "经历家庭变故后，林慧决定和丈夫一起面对生活的裂缝，也第一次主动争取属于自己的事业机会。",
    content:
      "丧事过后，家里恢复了久违的平静。林慧把压在箱子底的设计稿拿了出来，在餐桌上摊开，认真地和丈夫谈了一次：她想试着做点自己的事。陈志远沉默地听完，说“这次我陪你”。本集没有激烈的冲突，却充满向前的力量。晓彤在画纸上画下一家人和一个太阳，林慧把它贴在了新家的墙上。故事在温柔而不失锋芒的节奏里，走向重生。",
    airDate: "2024-04-17",
    director: "沈知远",
    writers: "林一舟、苏晓",
    cast: "苏雅宁、陆承轩、何以然",
    tags: ["重生", "家庭", "希望"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20chinese%20family%20sketching%20and%20talking%20together%20at%20bright%20kitchen%20table%20morning%2C%20warm%20hopeful%20sunlight%2C%20gentle%20new%20beginning%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep12&orientation=landscape",
  },
  {
    id: "ep-13",
    number: 13,
    season: 1,
    title: "小姑子的婚事",
    summary:
      "陈小雨带着交往对象回家，一场看似喜庆的见面饭，因家庭旧账被重提而暗流涌动。",
    content:
      "陈小雨带着男友第一次正式回家吃饭。饭桌上大家都笑着，话题却一次次拐到家产与旧事上。林慧察觉到婆婆的欲言又止，也看到丈夫紧绷的下巴。一顿团圆饭，吃出了三代人的心结。散席后，小雨拉着嫂子的手在楼下走了很久，说自己其实并不确定要不要结婚。林慧没有替她做决定，只说了句“想清楚再走”。",
    airDate: "2024-04-23",
    director: "沈知远",
    writers: "苏晓",
    cast: "方宁、苏雅宁、郑佩云",
    tags: ["婚事", "家庭", "代际"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20large%20chinese%20family%20dinner%20table%20with%20many%20dishes%2C%20ambiguous%20smiles%20and%20tension%2C%20warm%20indoor%20lighting%2C%20ensemble%20scene%2C%20film%20grain&width=800&height=450&seq=ym2-ep13&orientation=landscape",
  },
  {
    id: "ep-14",
    number: 14,
    season: 1,
    title: "高铭的诊断",
    summary:
      "晓彤体检出现异常，医生高铭的专业与耐心让林慧感到安心，也让这个家庭再次被推到风浪口。",
    content:
      "一次常规体检，让晓彤的化验单出现了几个异常的箭头。林慧慌乱中遇到了耐心解释的医生高铭，他用最平实的语言把复杂的情况说给她听。等待复查结果的几天里，全家人小心翼翼地维持着平静。夜里，林慧趴在女儿床边睡着，陈志远给她盖上毯子。本集把镜头对准父母最深的恐惧，也让人物关系在患难中变得更紧密。",
    airDate: "2024-04-24",
    director: "沈知远",
    writers: "林一舟",
    cast: "苏雅宁、温子健、何以然",
    tags: ["健康", "亲情", "考验"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20chinese%20doctor%20patiently%20explaining%20medical%20report%20to%20worried%20mother%20in%20bright%20clinic%2C%20clean%20soft%20light%2C%20calm%20reassuring%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep14&orientation=landscape",
  },
  {
    id: "ep-15",
    number: 15,
    season: 1,
    title: "风暴中的家",
    summary:
      "复查结果揭晓，虚惊一场的背后，是一家人真正学会了坦诚沟通，过去的隔阂开始松动。",
    content:
      "复查结果显示只是暂时性的问题。拿到报告那一刻，林慧蹲在医院走廊里哭了出来。回家的路上，陈志远主动提起了父亲的往事，也第一次向妻子道歉，说自己这些年只顾着逞强。晚上，一家三口坐在客厅地毯上拼一副很旧的拼图。拼图缺了一块，晓彤说没关系，缺的那块我们自己画。这句话成了整部剧最被观众记住的台词。",
    airDate: "2024-04-30",
    director: "沈知远",
    writers: "沈知远、林一舟",
    cast: "苏雅宁、陆承轩、何以然",
    tags: ["沟通", "亲情", "温暖"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20family%20of%20three%20sitting%20on%20living%20room%20floor%20doing%20jigsaw%20puzzle%20together%20at%20night%2C%20warm%20cozy%20lamp%20light%2C%20tender%20intimate%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-ep15&orientation=landscape",
  },
  {
    id: "ep-16",
    number: 16,
    season: 1,
    title: "阳光正好",
    summary:
      "第一季大结局。林慧的小工作室开张，婆媳在阳台种下第一盆花，这个普通的家庭终于走向属于自己的光。",
    content:
      "清晨的阳光穿过老楼的树影，落在新粉刷的墙面上。林慧的小工作室在街角开张，招牌是晓彤亲手写的字。王秀兰把一盆养的很好的绿萝搬到阳台，说从今天起好好养它。陈志远请了半天假，帮忙挂灯。没有惊天动地的和解，也没有大团圆的煽情，只是三个大人一个孩子，把日子过成了想要的样子。镜头最后拉远，老楼的灯一盏盏亮起。字幕出现：第一季 终。",
    airDate: "2024-05-01",
    director: "沈知远",
    writers: "沈知远、林一舟、苏晓",
    cast: "苏雅宁、陆承轩、郑佩云、何以然",
    tags: ["结局", "希望", "家庭"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20sunny%20morning%20light%20through%20tree%20shadows%20on%20balcony%20with%20green%20plants%20and%20painted%20wall%2C%20warm%20hopeful%20ending%20mood%2C%20soft%20golden%20tones%2C%20film%20grain&width=800&height=450&seq=ym2-ep16&orientation=landscape",
  },
];